import axios from "axios";
import { ADMIN_API } from "../../config";

/**
 * Renvoie l'historique des dates de connection selon l'intervalle.
 */
function getQuickHistory() {
  return axios
    .get(ADMIN_API + "/history/quick")
    .then((response) => response.data);
}

const api = {
  getQuickHistory,
};

export default api;
